/* eslint-disable @typescript-eslint/no-var-requires */
const HttpBackend = require('i18next-http-backend/cjs');
const ChainedBackend = require('i18next-chained-backend').default;
const LocalStorageBackend = require('i18next-localstorage-backend').default;

const isBrowser = typeof window !== 'undefined';

/** @type {import('next-i18next').UserConfig} */
module.exports = {
  backend: {
    backendOptions: [
      {
        // Options for LocalStorageBackend
        expirationTime: 60 * 60 * 1000, // 1 hour in milliseconds
      },
      {
        // Options for HttpBackend
        loadPath: '/locales/{{lng}}/{{ns}}.json',
      },
    ],
    backends: isBrowser ? [LocalStorageBackend, HttpBackend] : [],
  },
  debug: true,
  i18n: {
    defaultLocale: 'it',
    locales: ['en', 'it'],
  },
  partialBundledLanguages: isBrowser,
  serializeConfig: false,
  use: isBrowser ? [ChainedBackend] : [],
  ns: ['common'],
  defaultNS: 'common',
};
